/*
* @描述: 报价单下载
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-01-15 17:58:41
*/
<template>
    <el-dialog
            :before-close="handleDialogClose"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            custom-class="quotation_download_dialog"
            title="报价单下载"
            width="1054px">
        <div id="content" v-loading="loading" class="quotation_download_wrap">
            <TemplateComponent v-if="dataLoaded"
                               ref="templateComponent"
                               :fields_list="quotation_fields_list"
                               :project_quotation_tmpl_form="quotation_tmpl_form"
                               :quotation_detail="quotation_detail"
                               :templateType="'detail'"/>
        </div>
        <div slot="footer">
            <el-button size="small" @click="handleDialogClose">取消</el-button>
            <el-button size="small" type="primary" @click="handleClickDownload">下载</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import {projectQuotationDetail, projectQuotationDownload} from "@/api";
    import TemplateComponent from "@/views/pc/Business/component/template_component_detail";
    import jsPDF from 'jspdf';
    import html2canvas from 'html2canvas';

    export default {
        name: "quotationDownloadDialog",
        data() {
            return {
                quotation_tmpl_form: '',
                quotation_detail: {},
                quotation_fields_list: [],
                dataLoaded: false,
                loading: false,
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            quotation_id: {
                type: Number,
                default: 0,
            },
        },
        created() {
            this.loading = true
            projectQuotationDetail({
                project_quotation_id: this.quotation_id
            }).then(res => {
                if (res.code === 200) {
                    this.quotation_tmpl_form = res.data.project_quotation_tmpl_form
                    this.quotation_detail = res.data
                    this.quotation_fields_list = res.data.custom_fields
                    this.dataLoaded = true
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },
        mounted() {
        },
        components: {TemplateComponent},
        methods: {
            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },

            handleClickDownload() {
                projectQuotationDownload({
                    project_quotation_id: this.quotation_id
                }).then(res => {
                    if (res.code === 200) {
                    } else {
                        this.$message.error(res.message)
                    }
                })
                const element = document.getElementById('content');
                html2canvas(element).then((canvas) => {
                    const pdf = new jsPDF();
                    const imgData = canvas.toDataURL('image/png');
                    const imgWidth = 190; // 调整图像宽度
                    const pageHeight = pdf.internal.pageSize.height;
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;
                    const heightLeft = imgHeight;
                    let position = 0;
                    // 添加图像到 PDF
                    pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                    // 如果图像高度超过页面高度，则添加新页面并继续添加
                    if (heightLeft >= pageHeight) {
                        position = heightLeft - pageHeight;
                        while (heightLeft >= pageHeight) {
                            pdf.addPage();
                            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                            position -= pageHeight;
                        }
                    }
                    // 下载 PDF
                    pdf.save(this.quotation_detail.title + '.pdf');
                });
            },
        },
    }
</script>
<style lang="scss">
    .quotation_download_dialog {
        height: 80vh;
        display: flex;
        flex-direction: column;

        .el-dialog__body {
            flex: 1;
            overflow-y: auto;
        }

        .quotation_download_wrap {
            height: 100%;
        }
    }
</style>